module.exports = __webpack_public_path__ + "img/other_doll.da055c66.png";